export const minimalLayoutRoutes = [
    '/track/open'
]
